import * as React from "react";

const ADD_TO_CART_PATH = "/cart/add.js";

export const addToCart = (
  variant: { id: any },
  quantity = 1,
  properties: { [key: string]: any } = {},
  onSuccess: Function,
  onError: Function,
) => {
  if (variant) {
    fetch(ADD_TO_CART_PATH, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        quantity: quantity,
        id: variant.id,
        properties: properties,
      }),
    })
      .then(function () {
        updateCartIcon(quantity);
        onSuccess();
        // The Braze connector logs cart_updated ~470ms after this response
        // (measured on UAT) and the SDK then batches it for up to ~10s. Kick
        // a flush once the event exists so navigating away shortly after an
        // add does not strand it in the queue.
        setTimeout(function () {
          const braze = window.braze;
          if (braze && typeof braze.requestImmediateDataFlush === "function") {
            braze.requestImmediateDataFlush();
          }
        }, 600);
      })
      .catch(function (res) {
        onError();
      });
  }
};

const updateCartIcon = (quantity: number) => {
  const event = new CustomEvent("cart-change", {
    detail: { quantity: quantity },
  });
  window.dispatchEvent(event);
};
